import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LanguageService } from '../../services';
import { TranslatableSegment, translateSegments } from '../helpers/translate-segments';

@Injectable({
	providedIn: 'root',
})
export class RoutePathBuilderService {
	private readonly languageService = inject(LanguageService);

	/**
	 * @returns A long-living observable of array of relative paths that reacts to language changes
	 */
	public getRelative(segments: TranslatableSegment[], excludeFragment = false): Observable<Array<string>> {
		return this.languageService.selectedLanguage$.pipe(
			map((language) => {
				return translateSegments(segments, language, excludeFragment);
			})
		);
	}

	/**
	 * @returns A long-living observable of array of absolute paths that reacts to language changes
	 */
	public getAbsolute(segments: TranslatableSegment[], excludeFragment = false): Observable<Array<string>> {
		return this.languageService.selectedLanguage$.pipe(
			map((language) => {
				return ['/', language, ...translateSegments(segments, language, excludeFragment)];
			})
		);
	}
}
